import { daysToDateRange } from '../../lib/date-range-utils';

/** All Time (0) anchors to the first voice agent so the API's 90-day default doesn't silently truncate. */
export function resolveVoiceDateRange(
  selectedDays: number,
  firstVoiceAgentCreatedAt: string | null | undefined,
): { startDate?: string; endDate?: string } {
  if (selectedDays > 0) return daysToDateRange(selectedDays);
  return firstVoiceAgentCreatedAt ? { startDate: firstVoiceAgentCreatedAt } : {};
}

export function formatDuration(totalSecs: number | null): string {
  if (totalSecs == null || totalSecs <= 0) return '-';
  const hours = Math.floor(totalSecs / 3600);
  const mins = Math.floor((totalSecs % 3600) / 60);
  const secs = Math.round(totalSecs % 60);
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m ${secs}s`;
}

export function formatLatencyMs(ms: number | null): string {
  if (ms == null) return '-';
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.round(ms)}ms`;
}

export type LatencyLevel = 'good' | 'warn' | 'bad' | 'neutral';

/**
 * E2E P50 thresholds (Retell benchmark: P90 at 3s, so P50 should be well under)
 * Green: <= 1500ms | Yellow: 1500-2500ms | Red: > 2500ms
 */
export function getE2eP50Level(ms: number | null): LatencyLevel {
  if (ms == null) return 'neutral';
  if (ms <= 1500) return 'good';
  if (ms <= 2500) return 'warn';
  return 'bad';
}

/**
 * E2E P90 thresholds (Retell benchmark: 3000ms)
 * Green: <= 2500ms | Yellow: 2500-3000ms | Red: > 3000ms
 */
export function getE2eP90Level(ms: number | null): LatencyLevel {
  if (ms == null) return 'neutral';
  if (ms <= 2500) return 'good';
  if (ms <= 3000) return 'warn';
  return 'bad';
}

/**
 * LLM latency thresholds (Retell benchmark: normal range 500-900ms)
 * Green: <= 700ms | Yellow: 700-900ms | Red: > 900ms
 */
export function getLlmLatencyLevel(ms: number | null): LatencyLevel {
  if (ms == null) return 'neutral';
  if (ms <= 700) return 'good';
  if (ms <= 900) return 'warn';
  return 'bad';
}

export function formatCost(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function pct(n: number, total: number): number {
  return total === 0 ? 0 : (n / total) * 100;
}
